import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
function UGCSkeleton() {
  if (PUBLIC_IS_BOT) return null;
  return <div className='mt-8 w-full grow rounded border border-border-gray-light bg-surface-solid-0 px-2 py-3' data-sentry-component="UGCSkeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex w-full flex-col gap-2 lg:gap-3'>
                <div className='flex w-full justify-between'>
                    <div className='h-6 w-30 animate-pulse rounded bg-gray-100' />
                    <div className='h-10 w-25 animate-pulse rounded bg-gray-100' />
                </div>

                <div className='h-5 w-full animate-pulse rounded bg-gray-100 lg:h-6' />
                <div className='h-6 w-full animate-pulse rounded bg-gray-100' />

                <div className='w-full overflow-hidden'>
                    <div className='flex w-full gap-1.5'>
                        {Array(6).fill(undefined).map((_, index) => {
            return <div key={index} className='h-16 w-16 shrink-0 animate-pulse rounded bg-gray-100 lg:h-18 lg:w-18' />;
          })}
                    </div>
                </div>
            </div>

            {Array(2).fill(undefined).map((_, index) => {
      return <div className='flex flex-col' key={index}>
                            <div className='my-2 h-px w-full animate-pulse rounded bg-border-gray-light lg:my-3' />

                            <div className='h-[28px] w-full animate-pulse rounded bg-gray-100' />
                            {index % 2 === 1 && <div className='mt-1 h-[28px] w-full animate-pulse rounded bg-gray-100 lg:h-6' />}
                            <div className='mt-2 h-12 w-full animate-pulse rounded bg-gray-100 lg:mt-3' />
                            <div className='mt-2 h-5 w-full animate-pulse rounded bg-gray-100 lg:mt-3 lg:h-6' />
                        </div>;
    })}
        </div>;
}
export default UGCSkeleton;